<template>
	<Layout pageTitle="Registrarme" class="bg-white">
		<div class="container">
			<div class="row row-xs pb-5">
				<div class="col-12  mt-4 mb-5 justify-content-center bg-white">
					<div class="form-box">
						<h3 class="mt-3">{{ $t("title") }}</h3>
						<p>{{ $t("subtitle") }}</p>

						<Register />

						<router-link class="btn btn-block btn-text mt-5" tag="a" :to="`/login`">
							{{ $t("alreadyRegistered") }}</router-link
						>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from "@/components/Layout"
import Register from "./Register"

export default {
	name: "RegisterPage",
	metaInfo() {
		return {
			title: this.$t("title")
		}
	},
	components: {
		Layout,
		Register
	},

	i18n: {
		messages: {
			es: {
				title: "Registrarme",
				subtitle: "Registrarme",
				alreadyRegistered: "¿Ya tienes cuenta? Ingresar"
			},
			en: {
				title: "Sign up",
				subtitle: "Sign up",
				alreadyRegistered: "¿Ya tienes cuenta? Ingresar"
			},
			pt: {
				title: "Registrarme",
				subtitle: "Registrarme",
				alreadyRegistered: "Você já tem uma conta? Ingresar"
			}
		}
	}
}
</script>

<style scoped>
.form-box {
	margin: auto;
	flex-grow: 1;
	padding: 2rem 2rem;
	max-width: 400px;
}
h3 {
	font-size: 1.3rem;
	font-weight: 600;
}
</style>
